import { UAParser, type IBrowser } from 'ua-parser-js';

const redirect = "/unsupported-browser";
const supportedBrowsers = [
  { name: ['Chrome', 'Chrome Mobile'], version: 85 },
  { name: ['Firefox', 'Firefox Mobile'], version: 77 },
  { name: ['Safari', 'Mobile Safari'], version: 13.4 },
  { name: ['Edge'], version: 85 },
  { name: ['Opera'], version: 71 },
  { name: ['Samsung Internet'], version: 14 },
]
const supportedEngines = [
  { name: ['Blink'], version: 85 },
]

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  const { browser, engine } = UAParser(navigator.userAgent);
  // const { browser, engine } = UAParser('Mozilla/5.0 (Linux; Android 10; EML-L29 Build/HUAWEIEML-L29; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.106 Mobile Safari/537.36 [FB_IAB/FB4A;FBAV/504.0.0.69.64;]');

  const isUnsuportedPage: boolean = to.path === redirect;
  let isSupportedBrowser = true;

  if (browser.name && browser.version) {
    for (const supportedBrowser of supportedBrowsers) {
      if (supportedBrowser.name.includes(browser.name) && (parseInt(browser.version) < supportedBrowser.version)) {
        isSupportedBrowser = false;
        break;
      }
    }
  }

  if (engine.name && engine.version) {
    for (const supportedEngine of supportedEngines) {
      if (supportedEngine.name.includes(engine.name) && (parseInt(engine.version) < supportedEngine.version)) {
        isSupportedBrowser = false;
        break;
      }
    }
  }
  if (!isSupportedBrowser && !isUnsuportedPage) {
    return navigateTo(redirect, {
      replace: true,
    });
  }

  /* if (isSupportedBrowser && isUnsuportedPage) {
    return navigateTo("/", {
      replace: true,
    });
  } */
});